import script from "./Pla06ViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla06ViewPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__